/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { LinearProgress } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

const StyledProgressBar = styled(LinearProgress)<{
  theme: ICustomTheme;
  isDisabled: boolean;
  hasShadow: boolean;
}>(({ theme, isDisabled, hasShadow }) => {
  const backgroundColor = isDisabled
    ? theme.colors.grey.light
    : theme.colors.black.dark1;
  const border = isDisabled
    ? `solid 1px ${theme.colors.grey.light}`
    : `solid 1px ${theme.colors.black.dark1}`;
  const boxShadow = hasShadow ? '0 3px 6px 0 rgba(0, 0, 0, 0.16)' : 'unset';
  const color = isDisabled
    ? theme.colors.grey.dark
    : theme.colors.burgundyRed.red1;

  return {
    backgroundColor,
    border,
    borderRadius: theme.radius * 10,
    boxShadow,
    color,
    height: theme.spacing(2),
  };
});

export const ProgressBar = ({
  value = 0,
  isDisabled = false,
  hasShadow = true,
}: {
  value: number | undefined;
  isDisabled: boolean;
  hasShadow: boolean;
}): JSX.Element => (
  <StyledProgressBar
    variant="determinate"
    value={value}
    hasShadow={hasShadow}
    isDisabled={isDisabled}
  />
);

export default ProgressBar;
